export function getOptionsLabels(opts, value) {
	var opt = opts.find((x) => x.value == value);
	if (opt) {
		return opt.label;
	}
	return value;
}

export function valuesToOptions(values) {
	return values.map((x) => {
		return { label: x, value: x };
	});
}
